import {
    inject, observer,
} from 'mobx-react';
import {
    WithSnackbarProps,
} from 'notistack';
import React, {
    Component,
} from 'react';
import AlertDialog from '../../components/Dialog/alertDialog';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
    TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
    translate,
} from '../../helperFunctions/translation';

import {
    CountryStore,
} from '../../mobx-store/stores/countryStore';
import queryString from 'query-string';
import {facilityTypes} from '../facilitiesMangementScreen/facilities';
import {languageCodes} from '../../constants/languages';
import {IFacilityGroupStore} from "../../mobx-store/storeInterfaces/facilityGroupsInterface";

interface IProps extends WithSnackbarProps {
    facilityGroupStore: IFacilityGroupStore;
    countryStore: CountryStore;
    history: any;
    match: any;
    location: any;
}

interface IState {
    open: boolean;
}

@inject('facilityGroupStore')
@inject('countryStore')
@observer
class FacilityGroups extends Component<IProps, IState> {
    addButton: any;

    tableHeader: any = [];

    tableData: any[] = [];

    tableCellTypes: TableCellTypes[] = [];

    title: string;

    facilityGroupType: string;

    handleAgree: () => void = () => null;

    constructor(props: IProps) {
        super(props);
        this.title = translate('facilitiesGroupsListPageTitle', {});
        this.state = {
            open: false,
        };
    }

    handleTableButtonCellClicked = (index: number, key: string) => {
        this.props.history.push(`/facilities-group/${this.props.facilityGroupStore.groupsList[index].FacilityGroupId}/edit`);
    };

    handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
        if (!value) {
            this.handleAgree = () => {
                this.props.facilityGroupStore.updateFacilityGroupStatus(false, index)
                    .then(() => {
                        SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {}), 8000, 'success');
                    })
                    .catch((error: any) => {
                        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {}), 8000, 'error');
                    });
                this.setState({
                    open: false,
                });
            };
            this.handleClickOpen();
        } else {
            this.props.facilityGroupStore.updateFacilityGroupStatus(true, index)
                .then(() => {
                    SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {}), 8000, 'success');
                })
                .catch((error: any) => {
                    SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {}), 8000, 'error');
                });
        }
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    };

    handleAdd = (): void => {
        this.props.history.push(`/facilities-group/new`);
    };

    handleClose = () => {
        this.setState({
            open: false,
        });
    };

    getAddGroupButton = () => ({
        title: translate('addButton', {}),
        onAdd: this.handleAdd,
    });
    handleGenerateQRClicked = async (index: number, key: string) => {
        try {

            if (!this.props.facilityGroupStore.groupsList[index]) {
                SnackBarComponent.getInstance().openSnackbar(
                    'Error generating QR : Facility doesn\'t exist',
                    3000,
                    'error'
                );
                return;
            }

            alert(`You can generate QR code from AppsFlyer dashboard. id: group_${this.props.facilityGroupStore.groupsList[index].FacilityGroupId}`)

        } catch(error) {
            console.log(error);
        }
    }

    isGenerateBtnDisabled = (index: number) => !this.props.facilityGroupStore.groupsList[index].isActive;

    getGroupsTableHeader = () => {
        const tableHeaders = [
            {
                title: "ID",
            },
            {
                title: "Title",
            },

            {
                title: translate('editButton', {}),
            },
            {
                title: translate('facilitiesListGenerateColumnTitle', {})
            },
        ];


        return tableHeaders;

    };

    getGroupsTableData = () => this.props.facilityGroupStore.groupsList
        .map((Group) => ({
            ...Group, edit: 'Edit',
        }));

    handleEditForm = (index: number, key: string): void => {
        localStorage.setItem('parentRoute', '/facilities-group');
        this.props.history.push({
            pathname: `/facilities-form/${this.props.facilityGroupStore.groupsList[index].defaultQuestionsForm?.questionsFormId}/edit`,
        });
    };

    getGroupsTableCellTypes = (): TableCellTypes[] => {
        const cellTypes: TableCellTypes[] = [
            {
                cellType: 'Text',
                key: 'FacilityGroupId',
            },

            {
                cellType: 'Text',
                key: 'title',
            },


            {
                cellType: 'Button',
                key: 'edit',
                onClick: this.handleTableButtonCellClicked,
            },
            {
                cellType: 'Button',
                key: 'generate',
                disabled: this.isGenerateBtnDisabled,
                onClick: this.handleGenerateQRClicked,
            }
        ];

        const facilityType = this.getQueryParam();
        if (facilityType === facilityTypes.RATING) {
            cellTypes.push({
                cellType: 'Button',
                key: 'editForm',
                onClick: this.handleEditForm,
            });
        }

        return cellTypes;
    };

    returnTableData = () => {
        this.addButton = this.getAddGroupButton();
        this.tableHeader = this.getGroupsTableHeader();
        this.tableData = this.getGroupsTableData();
        this.tableCellTypes = this.getGroupsTableCellTypes();
    };

    render() {
        this.returnTableData();
        return (
            <div>
                <div>
                    <GeneralTableComponent
                        emptyMessage={translate('facilitiesGroupsListNoGroupsMessage', {})}
                        title={this.title}
                        tableHeader={this.tableHeader}
                        tableData={this.tableData}
                        tableCellTypes={this.tableCellTypes}
                        addButton={this.addButton}
                        loadingStatus={[
                            this.props.facilityGroupStore.getFacilitiesGroupsRequestStatus,
                            this.props.countryStore.getManagedCountriesRequestStatus
                        ]}
                    />
                </div>
                <div>
                    <AlertDialog
                        title="Wadi Degla Dashboard"
                        content={translate('facilitiesGroupsListDeactivationWarning', {})}
                        isOpen={this.state.open}
                        agree={this.handleAgree}
                        disAgree={this.handleClose}
                        hasActions
                    />
                </div>
            </div>
        );
    }

    getQueryParam = () => {
        const queryValues = queryString.parse(this.props.location.search);
        const facilityTypeToCall: any = (queryValues.type) ? queryValues.type : facilityTypes.ALL;

        return facilityTypeToCall;
    }

    async componentDidMount() {
        const {
            countryStore, facilityGroupStore,
        } = this.props;

        this.facilityGroupType = this.getQueryParam();

        await countryStore.getUserManagedCountries();
        facilityGroupStore.getFacilityGroups(countryStore.managedCountries, this.facilityGroupType, languageCodes.english);
    }
}

export default FacilityGroups;
